import React from 'react'
import Stockviewfile from '../../components/stockreportcomponents/Stockviewfile'


function  Stockview({renderPageContent}) {
    return (
        <>
                        <Stockviewfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Stockview
